import { render, staticRenderFns } from "./timeclock-punch-formatter.vue?vue&type=template&id=754eacd6&scoped=true"
import script from "./timeclock-punch-formatter.vue?vue&type=script&setup=true&lang=js"
export * from "./timeclock-punch-formatter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754eacd6",
  null
  
)

export default component.exports